import React from 'react';
import { View, Text, StyleSheet, Pressable, ActivityIndicator } from 'react-native';
import { MaterialIcons } from '@expo/vector-icons';
import { ChargerAttributes } from '../../models/charger-model';
//@ts-ignore
import SparklineChart, { SparklineDataPoint } from '../graphs/SparklineChart';

type Props = {
    index: number;
    data: ChargerAttributes;
    onRemove: (chargerId: string) => Promise<void> | void;
    onShowHistory: (chargerId: string) => void;
    sparklineData?: SparklineDataPoint[];
};

const MyChargerPartnerInfoCard: React.FC<Props> = ({ index, data, onRemove, onShowHistory, sparklineData }) => {
    const [removing, setRemoving] = React.useState(false);
    const [menuVisible, setMenuVisible] = React.useState(false);

    const handleRemove = async () => {
        if (!data?.uuid) return;
        if (removing) return;
        setRemoving(true);
        try {
            await onRemove(data.uuid);
        } finally {
            setRemoving(false);
        }
    };

    return (
        <View
            className="mt-4"
            key={index}
            style={{ backgroundColor: '#292D33', borderRadius: 16, position: 'relative' }}
        >
            <View className="flex flex-row justify-between items-center p-2">
                <View className="flex flex-row flex-1 items-center">
                    <View className="flex-1">
                        <Pressable onPress={() => setMenuVisible(v => !v)} style={{ flexDirection: 'row', alignItems: 'center', paddingVertical: 2, paddingHorizontal: 2 }}>
                            <MaterialIcons name="more-vert" size={18} color="#FFFFFF" />
                            <Text className="text-base font-bold text-white" style={[styles.alignEllipses, { marginLeft: 4 }]}>
                                {data?.name ? data?.name : 'Unknown Charger'}
                            </Text>
                        </Pressable>
                        <Text className="text-xs font-medium" style={[styles.textColor3, styles.alignEllipses, { marginLeft: 8 }]}>
                            {`${data.full_address}`}
                        </Text>
                        <View className="flex flex-row items-center mt-1" style={{ marginLeft: 8, marginTop: 10 }}>
                            <View
                                className={
                                    data?.isOccupied === 0 && data.is_enabled === true &&
                                    (data.status === 'complete' || data.status === null)
                                        ? 'px-3 py-1 rounded-full bg-[#51B868]'
                                        : 'px-3 py-1 rounded-full bg-[#F97777]'
                                }
                                style={{ paddingHorizontal: 14, paddingVertical: 6 }}
                            >
                                {data?.isOccupied === 0 && data.is_enabled === true &&
                                (data.status === 'complete' || data.status === null) ? (
                                    <Text className="text-xs text-white">Available</Text>
                                ) : (
                                    <Text className="text-xs font-bold text-white">In Use</Text>
                                )}
                            </View>
                        </View>
                    </View>
                </View>

                {/* Sparkline Chart Container */}
                <View className="justify-center items-center" style={styles.sparklineContainer}>
                    {sparklineData && Array.isArray(sparklineData) && sparklineData.length === 7 ? (
                        <SparklineChart 
                            data={sparklineData} 
                            width={120} 
                            height={76}
                            strokeColor="#39BEB7"
                            strokeWidth={5}
                        />
                    ) : (
                        // Placeholder to maintain layout stability
                        <View style={{ width: 120, height: 76 }} />
                    )}
                    <Pressable onPress={() => onShowHistory(data.uuid ?? '')} style={{ marginTop: 4, paddingVertical: 2, paddingHorizontal: 4, alignSelf: 'flex-end' }}>
                        <Text style={{ color: '#FFFFFF', fontSize: 12, fontWeight: '400' }}>Insights {'>'}</Text>
                    </Pressable>
                </View>
            </View>
            {menuVisible && (
                <View style={[StyleSheet.absoluteFillObject, { zIndex: 9 }]}>
                    <Pressable onPress={() => setMenuVisible(false)} style={StyleSheet.absoluteFillObject} />
                    <View style={{ position: 'absolute', top: 40, left: 10, backgroundColor: '#23262B', borderRadius: 8, paddingVertical: 6, width: 170, borderWidth: 1, borderColor: '#2F343C', zIndex: 10 }}>
                        <Pressable onPress={() => { setMenuVisible(false); handleRemove(); }} disabled={removing} style={{ paddingVertical: 8, paddingHorizontal: 12 }}>
                            {removing ? (
                                <ActivityIndicator size="small" color="#FFFFFF" />
                            ) : (
                                <Text style={{ color: '#F97777', fontSize: 14 }}>Remove Charger</Text>
                            )}
                        </Pressable>
                    </View>
                </View>
            )}
        </View>
    );
};

export default MyChargerPartnerInfoCard;

const styles = StyleSheet.create({
    TextColor1: {
        color: '#E8E8E9',
    },
    textColor3: {
        color: '#8D8E90',
    },
    alignEllipses: {
        fontWeight: '500',
        overflow: 'hidden',
        maxWidth: 150,
    },
    sparklineContainer: {
        borderRadius: 8,
        padding: 2,
        minWidth: 140,
        alignItems: 'center',
        marginTop: 0,
        marginBottom: 12,
    },
});